<template>
  <body id="apps" class="fixed-header menu-pin" >
    <main-sidebar />
    <main-header />
    <floating-loader-component v-if="is_loading" />
  </body>
</template>

<script>
import MainSidebar from "@/views/layout/sidebar.vue";
import MainHeader from "@/views/layout/header.vue";
import swal from "sweetalert";
import Cookie from "js-cookie";
import VueJwtDecode from "vue-jwt-decode";
import floating_loader from "@/views/components/floating_loader.vue";
export default {
  name: "MainLayout",
  components: {
    "main-sidebar": MainSidebar,
    "main-header": MainHeader,
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      renew_call: false,
    };
  },
  methods: {
    isIdle() {
      if (this.$store.state.idleVue.isIdle) {
        swal({
          title: "Anda idle selama 10 Menit",
          text: "Silahkan login kembali untuk melanjutkan.",
          icon: "warning",
          dangerMode: true,
          className: "swal-custom",
          closeOnClickOutside: false,
        }).then(() => {
          this.$store.dispatch("logout").then(() => {
            if (this.$route.path != "/login") {
              Cookie.set("medmon_last_page", this.$route.fullPath);
            }
            let ref = encodeURI(btoa("logout"));
            let teks = encodeURI(
              btoa("Sesi Anda telah berakhir, silakan masuk kembali.")
            );
            let title = encodeURI(btoa("Maaf!"));
            this.$router.push({
              path: "/login",
              query: { log: teks, ref: ref, log_t: title },
            });
          });
          return true;
        });
      }
      return false;
    },
  },
  created: function () {
    this.$http.interceptors.request.use((config) => {
      let api = process.env.VUE_APP_API_URL;
      let white_lists = [
        api + "login",
        api + "renew-access",
        api + "renew-refresh",
      ];

      if (!white_lists.includes(config.url)) {
        let refresh_token = Cookie.get("medmon_refresh");
        if (!refresh_token && !this.renew_call) {
          this.renew_call = true;
          this.$store.dispatch("logout").then(() => {
            if (this.$route.path != "/login") {
              Cookie.set("medmon_last_page", this.$route.fullPath);
            }
            let ref = encodeURI(btoa("logout"));
            let teks = encodeURI(
              btoa("Sesi Anda telah berakhir, silakan masuk kembali.")
            );
            let title = encodeURI(btoa("Maaf!"));
            this.$router.push({
              path: "/login",
              query: { log: teks, ref: ref, log_t: title },
            });
          });
        }

        let token = Cookie.get("medmon_ref");
        if (token && config.url.includes(api)) {
          config.headers["token"] = token;
        }
      }
      return config;
    });
    this.$http.interceptors.response.use(undefined, (error) => {
      let api = process.env.VUE_APP_API_URL + "renew-access";

      let refresh_token = Cookie.get("medmon_refresh");

      const originalRequest = error.config;

      if (error.response.status === 401 && originalRequest.url === api) {
        console.log("renew gagal");
        if (refresh_token) {
          originalRequest._retry = true;

          let api_refresh_token = process.env.VUE_APP_API_URL + "renew-refresh";
          let userID = this.$store.getters.user.user_id.$oid;
          let data = {
            "refresh-token": refresh_token,
            uid: userID,
          };

          return this.$http.post(api_refresh_token, data).then((res) => {
            if (res.status === 200) {
              let token = res.data["access-token"];
              this.$http.defaults.headers.common["token"] = token;

              let token_decode = VueJwtDecode.decode(token);
              let token_exp = token_decode.exp * 1000;
              let token_expire = new Date(token_exp);

              if (typeof remember_me !== "undefined") {
                Cookie.set("medmon_refresh", token);
              } else {
                Cookie.set("medmon_refresh", token, { expires: token_expire });
              }

              return this.$http(originalRequest);
            }
          });
        }
        return Promise.reject(error);
      }

      if (
        (error.response.status === 400 || error.response.status === 401) &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;

        if (typeof refresh_token !== "undefined") {
          let userID = this.$store.getters.user.user_id.$oid;
          let data = {
            "refresh-token": refresh_token,
            uid: userID,
          };

          return this.$http.post(api, data).then((res) => {
            if (res.status === 200) {
              let token = res.data["access-token"];
              this.$http.defaults.headers.common["token"] = token;

              let token_decode = VueJwtDecode.decode(token);
              let token_exp = token_decode.exp * 1000;
              let token_expire = new Date(token_exp);
              Cookie.set("medmon_ref", token, { expires: token_expire });

              return this.$http(originalRequest);
            }
          });
        }
      }

      return Promise.reject(error);
    });
  },
  computed: {
    is_loading: function () {
      return this.$store.getters.floating_loader;
    },
  },
  mounted: function () {
    this.$notification.requestPermission();
  },
};
</script>

<style>
.block-enter {
  opacity: 0;
}
.block-enter-active {
  transition: opacity 1s;
}
.block-leave {
}
.block-leave-active {
  transition: opacity 1s;
  opacity: 0;
}
</style>